import { environment } from '@env/environment';

export const hubConst = {
    ...environment,
    vimeo_url: 'https://player.vimeo.com/video/',
    cronaws: 'https://cronaws.educacaoadventista.org.br/',
    api: {
        ...environment.api,
        usuario_api: `${environment.protocolo}api-usuario.${environment.domain}/api/v1/`,
        usuario: `${environment.protocolo}api-usuario.${environment.domain}/api/`,
        voucher: `${environment.protocolo}api-vouchers.${environment.domain}/api/`,
        didaticos: `${environment.protocolo}api-didaticos.${environment.domain}/api/`,
        permissao_api: `${environment.protocolo}api-permissao.${environment.domain}/api/v2/`,
        conteudos_api: `${environment.protocolo}api-conteudos.${environment.domain}/api/`,
        vimeo_api: `${environment.protocolo}api-vimeo.${environment.domain}/api/v1/`,
        categories: `${environment.protocolo}api-categories.${environment.domain}/api/`,
        portal: `${environment.protocolo}api-portal.${environment.domain}/api/v1/`,
        bilingual_api: `${environment.protocolo}api-bilingual.${environment.domain}/api/v1/`,
        sky_english: `${environment.protocolo}api-bilingual.${environment.domain}/api/sky-english`,
        school_site_api: `${environment.protocolo}api-school.${environment.domain}/api/v1/`,
        local: `${environment.protocolo}${environment.url}/`,
        login: environment.login,
        avaliacoes_api: `${environment.protocolo}api-avaliacoes.${environment.domain}/api/v1/hub/`,
        vouchers: `${environment.protocolo}api-vouchers.${environment.domain}/api/`,
        logout: `${environment.login}/logout`,
        login_api: `${environment.login}/api/v1/`,
        assessments: `${environment.protocolo}api-avaliacoes.${environment.domain}/api`,
    },
    web: {
        ...environment.web,
    },
};


